/*
 * @Author: zhu.huijun
 * @Date: 2021-10-25 16:29:48
 * @Last Modified by: fansheng.meng
 * @Last Modified time: 2022-02-15 09:40:39
 */
import React from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Button, Row, Col, Checkbox, Upload } from '@whalecloud/fdx';

import { StepFooter } from '@/components';
import styles from './index.module.less';

const PortalReviewStep = props => {
  const { reviewData = [], loading, onPrevious, onJump, onSubmit, dispatch } = props;

  const handleEdit = step => {
    onJump(step);
  };

  const getLabelText = label => { // 兼容各种国际化写法
    if (isEmpty(label)) {
      return '';
    }
    if (i18n(label)) {
      return i18n(label);
    }
    return label;
  };

  const handleDownload = file => { // 下载
    const docId = get(file, 'url') || get(file, 'attachUrl') || get(file, 'response.data.docId');
    const docName = get(file, 'name');
    dispatch({
      type: 'business/downloadFile',
      payload: { docId, docName },
    });
  };

  const renderFileList = (fileList = []) => {
    const list = (fileList || []).map((it, index) => ({
      uid: index,
      name: it.name,
      status: 'done',
      url: it.attachUrl,
    }));
    return (
      <Upload
        listType="text"
        fileList={list}
        showUploadList={{
          showRemoveIcon: false,
          showDownloadIcon: true,
        }}
        onDownload={handleDownload}
      />
    );
  };

  const renderFormItem = (formItem = {}, index) => {
    const { hasImg, isCheckBox, disabled } = formItem;
    if (disabled) {
      return '';
    }
    const key = `${formItem.label}_${index}`;
    const labelText = getLabelText(formItem.label);
    if (isEmpty(labelText)) {
      return <Col className={styles.formItem} span={8} key={key} />;
    }
    if (!hasImg) {
      return (
        <Col className={styles.formItem} span={8} key={key}>
          {isCheckBox ? (
            <Checkbox checked>{labelText}</Checkbox>
          ) : (
            <Row type="flex">
              <Col span={12}>
                <div className={styles.label} title={labelText}>{labelText}</div>
              </Col>
              <Col span={12}>
                <div className={styles.value} title={formItem.value}>{formItem.value || '-'}</div>
              </Col>
            </Row>
          )}
        </Col>
      );
    }
    return (
      <Col span={24} key={key}>
        <Row type="flex">
          <Col span={4} className={styles.formItem}>
            <div className={styles.label}>{labelText}</div>
          </Col>
          <Col span={20} className={styles.formItem}>
            {
              (formItem.value && formItem.value.length > 0) ? renderFileList(formItem.value) : (<div className={styles.value}>-</div>)
            }
          </Col>
        </Row>
      </Col>
    );
  };

  const renderFormBox = (form = {}) => {
    if (form.disabled) {
      return '';
    }
    return (
      <div className={styles.formBox} key={form.id}>
        {form.formTitle && <h4 className="blockSubTitle">{getLabelText(form.formTitle)}</h4>}
        <Row type="flex" className={styles.formGroup}>{(form.itemList || []).map((formItem, index) => renderFormItem(formItem, index))}</Row>
      </div>
    );
  };

  return (
    <div className={`threeColumnWrap ${styles.reviewCom}`}>
      <div className={styles.reviewContain}>
        {reviewData.map((opt = {}) => (
          <div className="blockWrap" key={opt.moduleTitle}>
            <div className={styles.titleBox}>
              <h3 className="blockTitle">{getLabelText(opt.moduleTitle)}</h3>
              {
                // eslint-disable-next-line no-prototype-builtins
                opt.hasOwnProperty('step') ?
                  (
                    <Button onClick={() => handleEdit(opt.step)}>
                      <span className={`iconfont2 iconedit ${styles.icon}`} />
                      {getLabelText('COMMON_EDIT')}
                    </Button>
                  ) :
                  null
              }
            </div>

            {
              opt.component ?
                opt.component :
                (<div className={styles.content}>{(opt.formList || []).map(form => renderFormBox(form))}</div>)
            }
          </div>
        ))}
        {
          props.children ? props.children : <></>
        }
      </div>
      <StepFooter
        loading={loading}
        onPrevious={onPrevious}
        onContinue={onSubmit}
        continueContent={getLabelText('COMMON_CONFIRM')}
      />
    </div>
  );
};

export default connect()(PortalReviewStep);
